import { create } from "zustand";
import {
  fetchTokens as apiFetchTokens,
  createToken as apiCreateToken,
  revokeToken as apiRevokeToken,
  fetchDocs as apiFetchDocs,
  fetchDocsMarkdown as apiFetchDocsMarkdown,
} from "../services/developerService";

import { useErrorStore } from "components";

// Глобальний стор (state manager) сторінки "Розробник"
export const useDeveloperStore = create((set, get) => ({
  tokens: [],
  docs: null,
  newToken: null, // щойно створений токен: показується один раз
  isLoading: true,
  isCreating: false,

  // Ініціалізує стор: токени й документацію завантажуємо паралельно
  init: async () => {
    set({ isLoading: true });
    try {
      const [tokens, docs] = await Promise.all([apiFetchTokens(), apiFetchDocs()]);
      set({ tokens, docs });
    } catch (err) {
      const { showError } = useErrorStore.getState();
      showError(`Не вдалося завантажити сторінку розробника: ${err.message}`);
      console.error("Помилка ініціалізації сторінки розробника:", err);
    } finally {
      set({ isLoading: false });
    }
  },

  // Створює токен і показує його секретну частину один раз
  createToken: async (name) => {
    set({ isCreating: true });
    try {
      const created = await apiCreateToken(name);
      // У списку зберігаємо запис без секретної частини
      const listed = { ...created };
      delete listed.token;
      set({ newToken: created, tokens: [listed, ...get().tokens] });
      return true;
    } catch (err) {
      const { showError } = useErrorStore.getState();
      showError(`Не вдалося створити токен: ${err.message}`);
      console.error("Помилка створення токена:", err);
      return false;
    } finally {
      set({ isCreating: false });
    }
  },

  // Ховає банер із щойно створеним токеном
  clearNewToken: () => set({ newToken: null }),

  // Оптимістично відкликає токен
  revokeToken: async (tokenId) => {
    const previousTokens = get().tokens;
    set({ tokens: previousTokens.filter((token) => token.id !== tokenId) });
    if (get().newToken?.id === tokenId) set({ newToken: null });

    try {
      await apiRevokeToken(tokenId);
    } catch (err) {
      const { showError } = useErrorStore.getState();
      showError("Не вдалося відкликати токен. Зміни скасовано.");
      console.error("Помилка відкликання токена:", err);
      set({ tokens: previousTokens });
    }
  },

  // Копіює документацію у форматі Markdown у буфер обміну
  copyDocsMarkdown: async () => {
    try {
      const markdown = await apiFetchDocsMarkdown();
      await navigator.clipboard.writeText(markdown);
      return true;
    } catch (err) {
      const { showError } = useErrorStore.getState();
      showError(`Не вдалося скопіювати документацію: ${err.message}`);
      console.error("Помилка копіювання документації:", err);
      return false;
    }
  },
}));
